

















































import {Component, Inject, Prop, Vue, Watch} from 'vue-property-decorator'
import {debounce} from 'lodash'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {Helper} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'

@Component({components: {VueMultiselect}})
export default class SearchResponsavel extends Vue {
  @Prop({type: [Array, Object]}) value!: Responsavel | Responsavel[]

  @Prop({
    type: ResponsavelCollection,
    default: () => new ResponsavelCollection(),
  })
  collection!: ResponsavelCollection

  @Prop({type: String, default: null})
  label!: string | null

  @Prop({type: String, default: null})
  name!: string | null

  @Prop({type: String, default: null})
  inputClass!: string | null

  @Prop({type: Boolean, default: false})
  required!: boolean

  @Prop({type: Boolean, default: false})
  disabled!: boolean

  @Prop({type: String, default: ''})
  placeholder!: string

  @Prop({type: String, default: null})
  noResultLabel!: string | null

  @Prop({type: String, default: null})
  noOptionsLabel!: string | null

  @Prop({default: null})
  validation!: any

  @Prop({type: Boolean, default: true})
  cleanable!: boolean

  @Prop({type: Boolean, default: false})
  multiple!: boolean

  @Prop({type: Boolean, default: false})
  showLabels!: boolean

  readonly DEBOUNCE_TIMER = 500
  debouncedFind = debounce(
    async (search: string) => await this.find(search),
    this.DEBOUNCE_TIMER
  )

  isLoading = false

  mounted() {
    this.collection.noPagination()
  }

  get uid() {
    return Helper.uid
  }

  get computedModel() {
    return this.value
  }

  set computedModel(val: Responsavel | Responsavel[] | null) {
    this.$emit('input', val)
    this.collection.clear()
  }

  get isInvalid() {
    // @ts-ignore
    return this.errors.first(this.label ?? '')
  }

  get computedName() {
    return this.name || this.label || '-'
  }

  get isCleanable() {
    return (
      this.cleanable &&
      this.computedModel &&
      (this.computedModel as Responsavel[]).length !== 0
    )
  }

  async find(search: string) {
    if (search.length > 2) {
      this.isLoading = true

      const params = {ativo: true, searchResponsavel: true}

      this.collection.setSearch(search)
      this.collection.addFilter(params)
      await this.collection.queryAsPage()
      const collectionAux = [...this.collection.all()]
      this.collection.clear()
      this.collection.addAll(collectionAux)
      this.isLoading = false
    }
  }

  customLabel(responsavel: Responsavel) {
    if (responsavel.razaoSocial && responsavel.cnpj) {
      return `${responsavel.razaoSocial} - ${responsavel.cnpj}`
    } else {
      return (
        responsavel.razaoSocial || responsavel.nomeFantasia || responsavel.cnpj
      )
    }
  }

  emitEmpty() {
    this.$emit('input', null)
    this.collection.clear()
    this.collection.setSearch(null)
  }
}
